import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { PublicPageShell } from "@/components/PublicPageShell";
import { api } from "@/lib/api";

export default function PublicDailyLinks() {
  const [links, setLinks] = useState(null);

  useEffect(() => {
    api
      .get("/public/daily-links")
      .then((r) => setLinks(r.data))
      .catch(() => setLinks([]));
  }, []);

  const categorias = [...new Set((links || []).map((l) => l.categoria || "Geral"))];

  return (
    <PublicPageShell testId="links-page">
      <section className="bg-[#0A0A0A] py-16 lg:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-primary" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Dia a dia</span>
          </div>
          <h1 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="links-title">
            Links do Dia a Dia
          </h1>
          <p className="mt-3 max-w-2xl text-sm text-zinc-400">
            Links úteis e recorrentes do Instituto, reunidos em um só lugar.
          </p>
        </div>
      </section>

      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          {links === null && <p className="text-sm text-muted-foreground">Carregando...</p>}
          {links !== null && links.length === 0 && (
            <p className="border border-dashed border-border p-8 text-center text-sm text-muted-foreground" data-testid="links-empty">
              Nenhum link publicado no momento.
            </p>
          )}
          {categorias.map((cat) => (
            <div key={cat} className="mb-10" data-testid={`links-categoria-${cat}`}>
              <h2 className="font-heading text-xl font-bold">
                <span className="mr-2 inline-block h-4 w-1 bg-primary" />
                {cat}
              </h2>
              <div className="mt-4 space-y-3">
                {links
                  .filter((l) => (l.categoria || "Geral") === cat)
                  .map((l) => (
                    <a
                      key={l.id}
                      href={l.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group flex items-center justify-between gap-4 border border-border bg-white p-4 transition-all hover:-translate-y-0.5 hover:border-primary hover:shadow-md"
                      data-testid={`links-item-${l.id}`}
                    >
                      <span>
                        <span className="block font-heading text-base font-bold">{l.titulo}</span>
                        {l.descricao && <span className="mt-0.5 block text-sm text-muted-foreground">{l.descricao}</span>}
                      </span>
                      <ExternalLink size={16} className="shrink-0 text-muted-foreground transition-colors group-hover:text-primary" />
                    </a>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </PublicPageShell>
  );
}
